<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<h2>
				<i class="fa fa-pencil-ruler"></i>
				Project Bid Templates
			</h2>

			<projects-toolbar-controls
				:mobile-breakpoint="$store.tableListMobileBreakpoint">
			</projects-toolbar-controls>
		</toolbar>

		<div v-if="!categorySelected">
			<ul class="list-group">
				<li v-for="category in $store.categories" class="list-group-item list-group-item-action" v-on:click="selectCat(category)">
					{{ category.name }}
				</li>
			</ul>
		</div>
		<div v-else>
			<table-list
				record-name="Bid Template"
				:fields="[
					{label: 'Name',key: 'name'},
					{label: 'Template Scope',key:'scopeLabel'},
					{label: 'Created',key:'createdAt'}
				]"
				record-id
				:records="mutatedTemplates"
				id-field="slug"
				:has-delete="true"
				:has-edit="true"
				delete-endpoint="JobBid/delete"
				v-on:edit="editTemplate"
				v-on:modelChange="fetchTemplates(true)">

				<a href="#" v-on:click.prevent="backToCats">
					<i class="fa fa-arrow-left"></i>
					Back to Categories
				</a>

			</table-list>
		</div>

		<modal-dialog title="Edit Bid Template"
			:modal-visible="editTemplateModal.visible"
			v-on:confirm="saveTemplate"
			v-on:closeModal="editTemplateModal.visible = false">

			<field label="Bid Name"
				col-class="col-md-4"
				v-model="editTemplateModal.payload.name">
			</field>

			<field label="Notes (top)"
				col-class="col-md-4"
				v-model="editTemplateModal.payload.notes_top"
				:params="{type:'textarea'}">
			</field>

			<field label="Notes (bottom)"
				col-class="col-md-4"
				v-model="editTemplateModal.payload.notes_bottom"
				:params="{type:'textarea'}">
			</field>

		</modal-dialog>

	</div>
</template>

<script>
import Toolbar from "../layout_fragments/Toolbar"
import ProjectsToolbarControls from "./project/ProjectsToolbarControls"
import TableList from "@/components/TableList"
import NavTabs from "@/layout_fragments/NavTabs"

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

export default {

	name: 'Projects',
	components: {
		Toolbar,
		ProjectsToolbarControls,
		TableList,
		ModalDialog,
		Field,
		NavTabs
	},
	data() {
		return {
			templates: [],
			categorySelected: null,
			editTemplateModal: {
				visible: false,
				payload: {}
			}
		}
	},
	computed: {
		mutatedTemplates() {
			let vm = this

			return this.templates.map(temp => {
				temp.createdAt = vm.formatDateTimeToLocal(temp.created_at)

				temp.scopeLabel = "Full Bid"
				if (temp.template_is_structure_only == 1)
					temp.scopeLabel = "Structure Only"

				return temp
			})
		}
	},
	methods: {
		selectCat(category) {
			this.categorySelected = category

			this.fetchTemplates(true)
		},
		backToCats() {
			this.categorySelected = false
		},
		editTemplate(template) {
			this.editTemplateModal.visible = true
			this.editTemplateModal.payload = {
				name: template.name,
				notes_top: template.notes_top,
				notes_bottom: template.notes_bottom,
				id: template.id
			}
		},
		saveTemplate() {
			let vm = this

			this.postData("JobBid/save",this.editTemplateModal.payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Changes saved")
					vm.editTemplateModal.visible = false
					vm.fetchTemplates(true)
				}
			})
		},
		fetchTemplates(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {
				filters: [
					['is_template',1],
					["template_category_id",this.categorySelected.id]
				]
			}

			this.getJSON("JobBid/get",params).then(response => {
				if (response.success)
					vm.templates = response.data

				if (spinner)
					vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchJobCategories()
	}

}
</script>

<style type="text/css">

</style>